<template>
  <v-list-item   @click.native=setRes(index) :to="getItemURL(item)" target="_blank" two-line>
  <v-list-item-content>
    <v-row style="width=100%" no-gutters>
      <v-col :cols="hasThumb(item) ? 8 : 12">
        <v-list-item-title style="white-space: break-spaces;" v-html="getTitle(item)"></v-list-item-title>
        <v-list-item-subtitle v-html="getSubTitle(item)"></v-list-item-subtitle>
        <v-list-item-content class="mx-5 mb-0 py-0" v-html="getHighlighted(item)"></v-list-item-content>
      </v-col>
      <v-col cols=4 v-if="hasThumb(item)">
        <thumbnail
          :key="item.itemID"
          :masterImageID="getMasterImageID(item)"
          :url="getThumbNail(item)"
          :annotations="getAnnotations(item)"
          ref="thumbnails"
          :viewerName="item._id"
        />

        <!--v-img  style="max-width:100%;opacity:1" :src="getThumbNail(item)" @click.stop="navigation = !navigation" position="left" contain></v-img -->
      </v-col>
    </v-row>
  </v-list-item-content>
  </v-list-item>

</template>
<script>

import thumbnail from "./thumbnail.vue";
import {getOSDURL, getCaveLabel, getCaveShortLabel, getBibTitle, getWallLabels, filterRelatedAnnotationsByHighlight} from  "@/utils/helpers"
import {HighLightTranslator, serviceFields} from '@/utils/constants'
export default {
  components: {
    thumbnail
  },
  props: {
    item: Object,
    index: Number
  },
  data() {
    return {
      navigation: false
    };
  },
  methods: {
    setRes(res){
      this.$log.debug("setRes started")
      this.$log.debug('Setting result to', res);
      this.$store.commit('setResult', res)
    },
    getItemURL(item){
      var res = ""
      if (item._source.depictionID){
        res = "/pr/" + item._source.depictionID
      } else if (item._source.caveID){
        res = "/cave/" + item._source.caveID
      } else if (item._source.annotatedBibliographyID){
        res = "/bibliography/" + item._source.annotatedBibliographyID
      } else if (item._source.iconographyID){
        res = "/iconography/" + item._source.iconographyID
      }
      return res
    },
    hasThumb(item){
      if (item._source.depictionID || item._source.oe || item._source.caveID) {
        if (this.getThumbNail(item) !== null) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    getTitle(item){
      if (item._source.depictionID){
        return (item._source.cave === undefined || item._source.shortName === "") ? "Painted Representation " + item._source.depictionID :  "Painted Representation " + item._source.depictionID + " (" + item._source.shortName + ")"
      } else if (item._source.caveID){
        return this.getCaveLabel(item._source)
      } else if (item._source.annotatedBibliographyID){
        return "Annotated Bibliography: " + getBibTitle(item._source)
      } else if (item._source.iconographyID){
        return "KMT: " + item._source.text
      } else {
        return "unknown"
      }
    },
    getCaveLabel(item){
      return 'Cave ' + getCaveLabel(item)
    },
    getSubTitle(item){
      if (item._source.depictionID){
        return getCaveShortLabel(item._source.cave, "") + ",  " + getWallLabels(item._source, "")
      } else if (item._source.caveID){
        return null
      } else if (item._source.annotatedBibliographyID){
        return null
      } else if (item._source.iconographyID){
        return "(ID: " + item._source.iconographyID + ")"
      } else {
        return "unknown"
      }
    },

    getHighlighted(item){
      let res = ""
      if (item.highlight){
        const limit = 3
        let iteration = 1
        for (let key in item.highlight){
          if (!(key.includes(".search") || serviceFields.includes(key)) ){
            if (iteration > limit){
              break
            } else {
              iteration += 1
            }
            let keyText = ""
            console.log("key: ", key, item.highlight[key], key in HighLightTranslator);
            if (!(key in HighLightTranslator)){
              keyText = key
            } else {
              keyText = HighLightTranslator[key]
            }
            this.$log.debug("cleanHighlight", item.highlight[key][0], "after: ", this.cleanHighlight(item.highlight[key][0]))
            let text = "<p>" + keyText + ": " + this.cleanHighlight(item.highlight[key][0]) + "</p>"
            res += text
          }
        }
      }
      return res
    },
    /**
     * Gibt nur die relatedAnnotationList-Einträge zurück, die im highlight-Block vorkommen.
     * - Erkennt beliebige Pfade unter "relatedAnnotationList.*" (inkl. Arrays wie "tags.*")
     * - Ignoriert ".keyword"-Suffixe
     * - Vergleicht case-insensitive und diakritik-unabhängig (haṃsa ~ hamsa)
     * - Nutzt Teilstring-Matching (Fragment ⊆ Feldwert oder umgekehrt)
     */


    getAnnotations(item){
      return filterRelatedAnnotationsByHighlight(item)
    },

    getMasterImageID(item){
      this.$log.debug("getMasterImageID", item)
      if (item._source.depictionID){
        return item._source.masterImageID
      } else if (item._source.oe){
        this.$log.debug("getMasterImageID icono", item)
        return item._source.oe.masterImageID
      }
    },
    cleanHighlight(html) {
      this.$log.debug("cleanHighlight input:", html);

      // finde alle Highlight-Spans
      const spans = [...html.matchAll(/<span[^>]*>[\s\S]*?<\/span>/g)];

      if (spans.length === 0) return html;

      // Position des ersten und letzten Span ermitteln
      const firstSpan = spans[0];
      const lastSpan = spans[spans.length - 1];

      const firstSpanIndex = firstSpan.index;
      const lastSpanEndIndex =
        lastSpan.index + lastSpan[0].length;

      // Sandwich-Bereiche extrahieren
      let vorSpan = html.slice(0, firstSpanIndex);
      let zwischenSpan = html.slice(firstSpanIndex, lastSpanEndIndex);
      let nachSpan = html.slice(lastSpanEndIndex);

      // 1. vorSpan bereinigen: alles vor dem ersten '>' löschen
      const firstGt = vorSpan.indexOf(">");
      if (firstGt !== -1) {
        vorSpan = vorSpan.slice(firstGt + 1);
      }

      // 2. nachSpan bereinigen: alles nach dem letzten '<' löschen
      const lastLt = nachSpan.lastIndexOf("<");
      if (lastLt !== -1) {
        nachSpan = nachSpan.slice(0, lastLt + 1);
      }

      // 3. Office-Müll nur in den Span-Blöcken entfernen
      zwischenSpan = zwischenSpan.replace(/mso-[a-zA-Z\-]+:[^;"']+;?/g, "");

      const result = vorSpan + zwischenSpan + nachSpan;

      this.$log.debug("cleanHighlight output:", result);
      return result;
    },

    getThumbNail(item){
      this.$log.debug("getThumbNail", item)
      if (item._source.depictionID) {
        let masterImage = null
        for (const image of item._source.relatedImages){
          if (image.imageID === item._source.masterImageID){
            masterImage = image
            break
          }
        }
        if (masterImage !== null){
          if (masterImage.filename !== "accessNotPermitted.png"){
            return process.env.VUE_APP_IIIFAPI + ((window.location.origin.includes("test") || window.location.origin.includes("localhost")) ? "/iiif/2/kuchatest%2Fimages%2F" : "/iiif/2/kucha%2Fimages%2F") + masterImage.filename + "/info.json" // + "/full/!600,600/0/default.jpg"
          } else {
            return null
          }
        } else {
          return null
        }
      } else if (item._source.oe){
        this.$log.debug("getThumbNail icono", item._source.oe)
        let masterImage = null
        for (const image of item._source.oe.images){
          if (image.imageID === item._source.oe.masterImageID){
            masterImage = image
            break
          }
        }
        if (masterImage !== null){
          if (masterImage.filename !== "accessNotPermitted.png"){
            this.$log.debug("getThumbNail success", process.env.VUE_APP_IIIFAPI + "/iiif/2/kucha%2Fimages%2F" + masterImage.filename + "/info.json")
            return process.env.VUE_APP_IIIFAPI + ((window.location.origin.includes("test") || window.location.origin.includes("localhost")) ? "/iiif/2/kuchatest%2Fimages%2F" : "/iiif/2/kucha%2Fimages%2F") + masterImage.filename + "/info.json" // + "/full/!600,600/0/default.jpg"
          } else {
            return null
          }
        } else {
          return null
        }

      } else if (item._source.caveID) {
        const image = item._source.caveSketchList[0]
        if (image){
          return getOSDURL(image)
        } else {
          return null
        }
      } else {
        return null
      }
    },
  },

};
</script>
